import React from "react";
import { Redirect } from "react-router-dom";
import { isKidsSectionEnabled } from "./siteContent";

/**
 * Gate Kids browse / KidsLayout surfaces when the Kids section is disabled
 * or the user has no active profile session.
 */
function KidsVisibilityGate({ children }) {
  if (!isKidsSectionEnabled()) {
    return <Redirect to="/home" />;
  }
  const hasSession =
    localStorage.getItem("userId") && localStorage.getItem("accessToken");
  if (!hasSession) {
    return <Redirect to="/login" />;
  }
  if (!localStorage.getItem("active_profile_id")) {
    return <Redirect to="/view-profiles" />;
  }
  return children;
}

export default KidsVisibilityGate;
